// Converts a human label into a schema-safe key: lowercased, runs of
// non-alphanumerics collapsed to underscores, and trimmed of leading/trailing
// underscores. Returns `fallback` when nothing remains (e.g. the input was only
// punctuation or whitespace) so callers never emit an empty key the backend's
// SlugField would reject. Pass `fallback: ''` to opt out and chain candidates.
const slugify = (value: string, fallback = 'field'): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '') || fallback;

export default slugify;
